import { Box, CircularProgress } from '@mui/material'

export const Loading = ({ ...props }) => {
  return (
    <Box>
      <CircularProgress {...props} />
    </Box>
  )
}
